var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10938 4.57977C1.10938 3.73603 1.44455 2.92684 2.04117 2.33023C2.63778 1.73361 3.44696 1.39844 4.29071 1.39844H17.016C17.8598 1.39844 18.669 1.73361 19.2656 2.33023C19.8622 2.92684 20.1974 3.73603 20.1974 4.57977V15.1842C20.1974 16.0279 19.8622 16.8371 19.2656 17.4337C18.669 18.0304 17.8598 18.3655 17.016 18.3655H4.29071C3.44696 18.3655 2.63778 18.0304 2.04117 17.4337C1.44455 16.8371 1.10938 16.0279 1.10938 15.1842V4.57977Z",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8351 5.63965H15.956M13.8351 9.88142H15.956M5.35156 14.1232H15.956M5.35156 7.76054C5.35156 8.32303 5.57501 8.86249 5.97276 9.26023C6.3705 9.65797 6.90996 9.88142 7.47245 9.88142C8.03494 9.88142 8.5744 9.65797 8.97214 9.26023C9.36989 8.86249 9.59334 8.32303 9.59334 7.76054C9.59334 7.19804 9.36989 6.65859 8.97214 6.26084C8.5744 5.8631 8.03494 5.63965 7.47245 5.63965C6.90996 5.63965 6.3705 5.8631 5.97276 6.26084C5.57501 6.65859 5.35156 7.19804 5.35156 7.76054Z",
    stroke: "#E9A5F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIds);
export default __webpack_public_path__ + "static/media/ids.fe76fa1f3c3227fa7bafe9c1f399336b.svg";
export { ForwardRef as ReactComponent };